<template>
  <div class="box">
    <div id="app-home">
      <!-- <div class="top">
        恭喜{{ $store.state.userInfo.nickname }}荣获{{ list.medalName }}
      </div> -->
      <!-- <div class="top">恭喜{{ list.receivername }}荣获{{ list.medalName }}</div> -->
      <div class="icon">
        <img
          @click="handleCheckDetail"
          class="img1"
          :src="imgUrl + list.iconId"
          alt=""
        />
      </div>
      <div class="check_con" @click="handleCheckDetail">查看获奖项目</div>
      <!-- <img class="img2" :src="list.receivericon" alt="" /> -->
      <img class="img2" :src="list.receivericon" alt="" />
      <!-- <img class="img2" v-else :src="$store.state.userInfo.icon" alt="" /> -->
      <div class="message">
        <div class="name">亲爱的{{ list.receivername }}</div>
        <!-- <div class="name" v-else>亲爱的{{ $store.state.userInfo.nickname }}</div> -->
        <div class="content" v-if="list.remarks">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 恭喜您！您所参与的【
          <span
            @click="handleCheckDetail"
            style="color: #fff; font-weight: bold"
            >{{ list.title }}</span
          >
          】项目，荣耀加冕，荣获了【 <span>{{ list.medalName }}</span> 】！<span
            v-html="list.remarks"
          ></span>
        </div>
        <div class="content" v-else>恭喜您获得{{ list.medalName }}</div>
      </div>
      <div class="footer">
        <img src="../../../assets/newMedal/kkq/cs.svg" alt="" />
        <div>
          {{ list.ccers }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//   import moment from "moment";
//   import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
import api from "@/apis/medal";
import apiLogin from "@/apis";
export default {
  name: "medalDetail",
  components: {},
  data() {
    return {
      id: "",
      list: {},
      imgUrl: "",
      empno: ""
    };
  },
  created() {},
  mounted() {
    this.imgUrl = api.imgUrl;
    this.id = this.$route.query.id;
    let token = window.sessionStorage.empNo;
    let hrToken = getToken();
    //获取hrToken
    if (token) {
      this.empno = hrToken;
      this.getList(token);
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
          this.getList(res);
        });
      });
    }
  },
  beforeDestroy() {
    sessionStorage.setItem("isShowBadge", true);
  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then(data => {
            const info = data.data;

            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));

            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //获取徽章信息
    getList(token) {
      api
        .medalCardDetailApi({
          id: this.id,
          empno: token,
          channel: this.$route.query.value
        })
        .then(res => {
          if (res.code == 200) {
            const checkList =
              res.data.receiverEmpno +
              "," +
              res.data.senderEmpno +
              "," +
              res.data.ccEmpno;
            if (checkList.includes(token)) {
              this.list = res.data;
              this.list.ccers = res.data.ccers.join(";");
            } else {
              this.$router.push({
                path: "/mobile/medal"
              });
            }
          }
        })
        .catch(err => {
          if (err.code === 0) {
            this.$message({
              type: "error", // success error warning
              message: err.message,
              duration: 2000
            });
          }
        });
    },
    //点击查看获奖项目，跳转往期项目详情
    handleCheckDetail() {
      localStorage.setItem("historyDetail", JSON.stringify(this.list));
      this.$router.push("/mobile/medal/newsNotice/historyDetail");
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
    // background: rgba(244, 245, 248, 1);
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg4.png");
    background-size: 100% 100%;
    position: absolute;
  }
}

@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
    // background: rgba(244, 245, 248, 1);
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg4.png");
    background-size: 100% 100%;
    position: absolute;
  }
}

.box {
  width: 100%;
  display: flex;
  justify-content: center;
}
.top {
  position: absolute;
  top: 5%;
  left: 0%;
  right: 0;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 54px;
  font-weight: 600;
  background: linear-gradient(
    180deg,
    rgba(255, 243, 223, 1) 0,
    rgba(198, 147, 90, 1) 99.95083%
  );
  color: transparent;
  letter-spacing: 4px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.icon {
  position: absolute;
  top: 2%;
  left: 0%;
  width: 100%;
  display: flex;
  justify-content: center;
  .img1 {
    width: 380px;
    // height: 480px;
  }
}
.check_con {
  font-family: PingFangSC, PingFang SC;
  position: absolute;
  top: 31vh;
  left: 0%;
  width: 100%;
  background: linear-gradient(180deg, #fff3df 0%, #c6935a 100%);
  font-weight: bold;
  color: transparent;
  letter-spacing: 4px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  font-size: 30px;
}
.img2 {
  width: 95px;
  height: 95px;
  position: absolute;
  top: 38%;
  left: 19%;
  border-radius: 50%;
}
.message {
  position: absolute;
  top: 52%;
  left: 15%;
  right: 10%;
  color: #ffe6b8;
  .name {
    font-size: 36px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  .content {
    width: 100%;
    font-size: 28px;
    font-weight: 400;
    line-height: 50px;
    height: 33vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.footer {
  width: 100%;
  height: 7%;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding: 0 30px;
  color: #ffe6b8;
  img {
    width: 50px;
    height: 50px;
    margin-right: 15px;
  }
  div {
    flex: 1;
    font-size: 28px;
    overflow-x: auto;
    white-space: nowrap;
    // width: 43%;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
